import { fetcherClient } from 'shared/lib/fetcher'
import { convertObjectToQueryString } from 'shared/utils'

export const getEndUser = (params) => {
  const { queryString } = convertObjectToQueryString(params)
  return fetcherClient.get(`user/admin/list?${queryString}`)
}

export const getEndUserDetail = ({ id }) => {
  return fetcherClient.get(`user/admin/${id}`)
}

export const getUserCount = ({ id }) => {
  return fetcherClient.get('user/admin/user-counts')
}
